import Popover from '@material-ui/core/Popover';
import DeActive from 'assets/icons/svg/deActive';
import React, { useEffect, useState } from 'react';
import ActionSvgComponent from '../assets/icons/svg/actionSvg';
import DeleteSvgComponent from '../assets/icons/svg/DeleteSvg/Delete';
import EditSvgComponent from '../assets/icons/svg/Edit/index';
import { ReactComponent as ReversalSvg } from 'assets/icons/reversal.svg';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import UserService from '../Lib/API/users';
import { useAuth0 } from '@auth0/auth0-react';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import './style.scss';
import { toastr } from 'react-redux-toastr';

export default function UserPopover({
  onEditClick,
  onDeleteClick,
  checkActive,
  onActiveClick,
  onReversalClick,
  style,
  setUpdateUserRow,
  setIsUpdateUserDrawerOpen,
  row,
  setRefresh,
  refresh,
  setOpenAlertDelete,
  setDeleteHandle,
  deleteHandle,
  setOpenAlertBlock,
  setblockHandle,
  blockHandle,
  setUserId,
  userId,
  setBlockedRow,
  MoreVert,
  activeUesr,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { getAccessTokenSilently } = useAuth0();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <div>
        {MoreVert ? (
          <MoreVertIcon
            color="primary"
            className="more__hor"
            onClick={handleClick}
          />
        ) : (
          <MoreHorizIcon
            color="primary"
            className="more__hor"
            onClick={handleClick}
          />
        )}
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className="popover-action-user">
          <div
            key={row._id}
            onClick={() => {
              setUpdateUserRow(row);
              setIsUpdateUserDrawerOpen(true);
              setAnchorEl(null);
            }}
            className="action__user"
          >
            Edit
          </div>
          <div
            className="action__user"
            onClick={() => {
              setUserId(row._id);
              setOpenAlertDelete(true);
            }}
          >
            Delete
          </div>
          <div
            className="action__user"
            onClick={() => {
              setUserId(row._id);
              setBlockedRow(row);
              setOpenAlertBlock(true);
            }}
          >
            {activeUesr === true ? "Disabled" : "Enable"}
          </div>
        </div>
      </Popover>
    </div>
  );
}